import React from 'react';
import loadable from '@loadable/component';

const SafariDetail = loadable(() => import('../components/SafariDetail/SafariDetail'));

const SafariDetailPage = () => <SafariDetail />;

export default SafariDetailPage;